import { ClinicSearchResult } from '@/api/algolia';
import { makeSearchTitle } from './search';

export const convertSearchResponseIntoListingInfo = (
  searchHealthcareService?: string,
  searchLocation?: string,
  searchResponse?: ClinicSearchResult,
) => {
  if (!searchResponse) return {};
  const total = searchResponse?.nbHits;
  if (total === undefined) return {};

  return {
    title: makeSearchTitle({ service: searchHealthcareService, location: searchLocation, total }),
    results: searchResponse?.hits ?? [],
    total,
    pages: searchResponse?.nbPages,
  };
};
